<template>
  <main>
    <div class="main-container">

      <b-alert v-model="error" variant="danger" dismissible>
        {{ msg_alert }}
      </b-alert>

      <div class="h-100">

        <SearchFilter @search="refresh"/>
        <b-button href="/create/user" variant="primary"> Nouveau client</b-button>

        <div class="mt-4">
          <b-card-group deck>
            <b-card v-for='user in get_filter_client()'>

              <b-card-text>

                <!-- Nom + actions -->
                <div class="d-flex">
                  <p class="text-primary">{{ user.name }}</p>

                  <router-link
                      class="icon-style"
                      :to="{ name: 'create-user-view', params: { user: user } }">
                    <font-awesome-icon
                        class="text-primary"
                        icon="fa-solid fa-pencil"/>
                  </router-link>

                  <a @click="deleteUser(user.id)" class="ml-4 icon-style">
                    <font-awesome-icon
                        class="text-primary"
                        icon="fa-solid fa-trash"/>
                  </a>
                </div>

                <p v-if="user.tel">
                  Tel: {{ user.tel }}
                </p>

                <p v-if="user.fid">
                  Carte fidélité: {{ user.fid }}
                </p>

                <!-- Cartes Pokémon -->
                <p v-if="user.is_card">
                  Cartes Pokémon :
                  <strong>{{ [user.is_vf && 'VF', user.is_vo && 'VO', user.is_kr && 'KR'].filter(Boolean).join(' / ') }}</strong>
                </p>

                <p v-if="user.notes">Notes: {{ user.notes }}</p>

                <!-- Événements -->
                <div v-if="user.events.length" class="events-container">
                  <span v-for="event in user.events" :key="event" class="event-badge">
                    {{ event }}
                    <button type="button" class="event-remove"
                            :aria-label="`Désinscrire ${user.name} de ${event}`"
                            :title="`Supprimer l'inscription à ${event}`"
                            :disabled="removingEvent !== null || !events.some(item => item.name === event)"
                            @click="removeUserFromEvent(user.id, event)">
                      <font-awesome-icon icon="fa-solid fa-trash"/>
                    </button>
                  </span>
                </div>
              </b-card-text>


              <hr v-if="availableEvents(user).length" class="events-separator">
              <div v-if="availableEvents(user).length" class="events-container available-events">
                <b-button v-for="event in availableEvents(user)" :key="event.id" size="sm"
                          class="event-add" @click="addUserToEvent(user.id, event)">
                  + {{ event.name }}
                </b-button>
              </div>


            </b-card>
          </b-card-group>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {add_user_evenement, delete_user, delete_user_event, get_all_detail_users, get_all_events} from "@/services/ApiServices";
import SearchFilter from "@/components/SearchFilter.vue";

export default {
  name: "list-user-view",
  components: {SearchFilter},
  data() {
    return {
      users: [],
      events: [],
      input: '',
      error: false,
      msg_alert: '',
      removingEvent: null,
    }
  },
  methods: {
    displayAlert(is_success, msg = "L'utilisateur a bien été créé") {
      this.visible_alert = true;
      this.msg_alert = msg;
      this.class_alert = is_success ? "success" : "danger";
    },
    refresh(data) {
      this.input = data
    },
    get_filter_client() {
      return this.users.filter((item) => { // filter in name
            const f_item = item['name'].toLowerCase()
            return f_item.includes(this.input.toLowerCase())
          }
      );
    },
    deleteUser(user_id) {
      delete_user(user_id).then(response => {
        this.users = response
      }).catch(error => {
        this.error = true;
        this.msg_alert = error.message
      });
    },
    availableEvents(user) {
      return this.events.filter(event =>
          !user.events.includes(event.name)
      )
    },
    async removeUserFromEvent(user_id, eventName) {
      if (this.removingEvent !== null) return;
      const event = this.events.find(item => item.name === eventName);
      if (!event) return;
      this.removingEvent = `${user_id}:${event.id}`;
      try {
        await delete_user_event(user_id, event.id);
        window.location.reload();
      } catch (error) {
        this.error = true;
        this.msg_alert = error.message;
        this.removingEvent = null;
      }
    },
    addUserToEvent(user_id, event) {
      add_user_evenement({"user_id": user_id, "event_id": event.id, "event_name": event.name}).then(() => {
        window.location.reload()
      }).catch(error => {
        this.error = true;
        this.msg_alert = error.message
      })
    }
  },
  created() {
    get_all_detail_users().then(response => {
      this.users = response;
      console.log(this.users[0]);
    }).catch(error => {
      this.error = true;
      this.msg_alert = error.message
    })
    get_all_events().then(response => {
      this.events = response;
      console.log(this.events);
    })

  }


}
</script>

<style scoped>

.events-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 15px;
}

.event-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid #287bc1;
  border-radius: 6px;
  color: #fff;
  background-color: #287bc1;
  font-size: 14px;
  font-weight: bolder;
  font-family: monospace;
  letter-spacing: 0.3px;
  text-transform: capitalize;
}

.event-remove {
  border: 0;
  border-radius: 3px;
  padding: 3px 5px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.event-remove:hover,
.event-remove:focus-visible {
  background: #ffffff33;
  outline: 2px solid #fff;
}

.event-remove:disabled {
  opacity: 0.5;
  cursor: wait;
}

.icon-style {
  margin: 0 0 0 auto;
  width: auto;
  font-size: 19px;
}

.card-deck .card {
  margin-bottom: 15px;
}

.btn {
  margin: 10px auto;
  display: flex;
  max-width: 295px;
  justify-content: center;
}

.events-separator {
  border: 0;
  border-top: 1px solid #b8c8d8;
  margin: 16px 0;
}

.available-events {
  margin-top: 0;
}

.available-events .event-add {
  display: inline-flex;
  margin: 0;
  max-width: 100%;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background-color: #c6fb73a8;
  color: #203608;
  font-size: 14px;
  font-weight: bolder;
  font-family: monospace;
  letter-spacing: 0.3px;
  text-transform: capitalize;
}

.available-events .event-add:hover,
.available-events .event-add:focus {
  background-color: #91cc38;
  border-color: #557d1b;
  color: #203608;
}

@media (min-width: 576px) {
  .card-deck .card {
    min-width: 28%;
    max-width: 28%;
  }

  a {
    margin: 10px 0;
  }

  .btn {
    margin: 10px 0;
  }
}

</style>
